import { useState } from 'react';
import '../styles/pages/Contact.css';
import useReveal from '../components/useReveal';
import PRODUCTS from '../data/products';

const CONTACT_INFO = [
  { icon: '🏢', title: 'Corporate Office',      value: 'Unit No. 209, Tower-D, Pioneer Urban Square, Sector 62, Gurugram, India' },
  { icon: '🏭', title: 'Manufacturing Facility', value: '710-711, MIE, Bahadurgarh, Haryana — 124507, India' },
  { icon: '📧', title: 'Export Enquiries',        value: 'export@pharmchem.net',      href: 'mailto:export@pharmchem.net' },
  { icon: '📧', title: 'Domestic Sales',          value: 'sales@pharmchem.net',       href: 'mailto:sales@pharmchem.net' },
  { icon: '👤', title: 'Management',              value: 'nipun@pharmchem.net',  href: 'mailto:nipun@pharmchem.net' },
  { icon: '📱', title: 'Mobile',                  value: '+91 98108 20562',           href: 'tel:+919810820562' },
  { icon: '🌐', title: 'Website',                 value: 'www.phrmchem.net',          href: 'http://www.phrmchem.net' },
];

const COUNTRIES = [
  'India','United Arab Emirates','Bangladesh','Argentina','Bolivia','Cambodia',
  'Chile','Colombia','Egypt','Ethiopia','Germany','Ghana','Guatemala',
  'Indonesia','Kenya','Mexico','Nepal','Nigeria','Pakistan','Peru',
  'Sudan','Switzerland','Tanzania','Thailand','Other',
];

function Contact() {
  useReveal();
  const [sent, setSent] = useState(false);

  const handleSubmit = () => {
    setSent(true);
    setTimeout(() => setSent(false), 4000);
  };

  return (
    <>
      {/* Page hero */}
      <div className="page-hero">
        <div className="page-hero-bg"></div>
        <div className="page-hero-inner">
          <div className="eyebrow">Get In Touch</div>
          <h1 className="headline">
            Let's Build Something <em>Together</em>
          </h1>
          <p>
            Whether you're looking for a new API supplier or want to expand your existing
            partnership with Pharmchem, our team is ready to assist.
          </p>
        </div>
      </div>

      {/* Contact section */}
      <div className="contact-page">
        <div className="contact-inner">

          {/* Left — info card */}
          <div>
            <div className="contact-info-block">
              <div className="cib-header">
                <h3>Pharmchem</h3>
                <p>Building Business through Long Term Relations</p>
              </div>
              <div className="cib-body">
                {CONTACT_INFO.map((ci) => (
                  <div className="ci-row" key={ci.title}>
                    <div className="ci-icon">{ci.icon}</div>
                    <div className="ci-text">
                      <strong>{ci.title}</strong>
                      {ci.href
                        ? <a href={ci.href} target={ci.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer">{ci.value}</a>
                        : ci.value
                      }
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right — enquiry form */}
          <div className="contact-form-wrap">
            <h3>Send an Enquiry</h3>
            <p>Fill in the form below and our team will get back to you within 24 hours.</p>

            <div className="form-grid">

              {/* Name row */}
              <div className="form-group">
                <label>First Name</label>
                <input type="text" placeholder="John" />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input type="text" placeholder="Doe" />
              </div>

              {/* Contact row */}
              <div className="form-group">
                <label>Email Address</label>
                <input type="email" placeholder="john@company.com" />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <input type="tel" placeholder="+1 234 567 8900" />
              </div>

              {/* Company */}
              <div className="form-group form-full">
                <label>Company Name</label>
                <input type="text" placeholder="Your pharmaceutical company" />
              </div>

              {/* Country */}
              <div className="form-group form-full">
                <label>Country</label>
                <select defaultValue="">
                  <option value="" disabled>Select your country…</option>
                  {COUNTRIES.map((c) => <option key={c}>{c}</option>)}
                </select>
              </div>

              {/* Product */}
              <div className="form-group form-full">
                <label>Product(s) of Interest</label>
                <select defaultValue="">
                  <option value="" disabled>Select a product…</option>
                  {PRODUCTS.map((p) => <option key={p.name}>{p.name}</option>)}
                  <option>Multiple Products</option>
                  <option>General Enquiry</option>
                </select>
              </div>

              {/* Message */}
              <div className="form-group form-full">
                <label>Message / Requirements</label>
                <textarea placeholder="Please describe your requirements — quantity, specifications, delivery timeline, or any other details…"></textarea>
              </div>

              {/* Submit */}
              <div className="form-full">
                <button
                  className={`form-submit ${sent ? 'sent' : ''}`}
                  onClick={handleSubmit}
                >
                  {sent ? "✓ Enquiry Sent! We'll respond within 24 hours." : 'Send Enquiry →'}
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Contact;
